import React, {useEffect} from "react";
import { motion } from "framer-motion";
import Breadcrumb from "../Components/Breadcrumb";
import Cta from "../Components/Cta";

const CancellationRefund=()=>{
      const fadeUp = {
  hidden: {
    opacity: 0,
    y: 40,
    filter: "blur(8px)",
  },
  visible: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: {
      duration: 0.7,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

const stagger = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.08,
    },
  },
};

const itemVariant = {
  hidden: {
    opacity: 0,
    y: 30,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.55,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

useEffect(() => {
    document.title =
      "Cancellation & Refund Policy | ONBBITS";

    const metaDesc = document.querySelector("meta[name='description']");
    if (metaDesc) {
      metaDesc.setAttribute(
        "content",
        "Learn about ONBBITS cancellation, subscription termination and refund policy, including eligibility, billing and payment guidelines."
      );
    }

     const canonical = document.querySelector("link[rel='canonical']");
  if (canonical) {
    canonical.setAttribute("href", "https://onbbits.io/cancellation-refund");
  }

  const ogTitle = document.querySelector("meta[property='og:title']");
  if (ogTitle) {
    ogTitle.setAttribute(
      "content",
      "Cancellation & Refund Policy | ONBBITS"
    );
  }

    const ogDesc = document.querySelector("meta[property='og:description']");
  if (ogDesc) {
    ogDesc.setAttribute(
      "content",
      "Learn about ONBBITS cancellation, subscription termination and refund policy, including eligibility, billing and payment guidelines."
    );
  }

  const ogUrl = document.querySelector("meta[property='og:url']");
  if (ogUrl) {
    ogUrl.setAttribute("content", "https://onbbits.io/cancellation-refund");
  }

    const ogImage = document.querySelector("meta[property='og:image']");
  if (ogImage) {
    ogImage.setAttribute(
      "content",
      "https://onbbits.io/Images/hero-img.webp"
    );
  }

    const twitterTitle = document.querySelector("meta[name='twitter:title']");
  if (twitterTitle) {
    twitterTitle.setAttribute(
      "content",
      "Cancellation & Refund Policy | ONBBITS"
    );
  }

    const twitterDesc = document.querySelector(
    "meta[name='twitter:description']"
  );
  if (twitterDesc) {
    twitterDesc.setAttribute(
      "content",
      "Learn about ONBBITS cancellation, subscription termination and refund policy, including eligibility, billing and payment guidelines."
    );
  }

    const twitterImage = document.querySelector("meta[name='twitter:image']");
  if (twitterImage) {
    twitterImage.setAttribute(
      "content",
      "https://onbbits.io/Images/hero-img.webp"
    );
  }
  }, [])

    return(
        <>
        {/**BREADCRUMB */}
        <Breadcrumb title="Cancellation And Refund Policy" />

         <motion.section
            className="policy-section container"
            variants={stagger}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.05 }}
        >
        <motion.p
            className="section-text"
            variants={itemVariant}>This Cancellation and Refund Policy ("Policy") applies to users of ONBBITS (hereinafter referred to as "Platform", "ONBBITS", "Website", or "Service"), a SaaS-based WhatsApp automation and chatbot builder platform owned and operated by Onbbits ("Company", "we", "us", or "our").</motion.p>
        <motion.p
            className="section-text"
            variants={itemVariant}>By subscribing to ONBBITS, you agree to this Policy as part of our Terms of Service. This document outlines how subscription cancellations and refund requests are handled.</motion.p>

         <motion.h2 className="section-heading" variants={fadeUp}>1. Overview</motion.h2>
         <motion.p
            className="section-text"
            variants={itemVariant}>At ONBBITS, we are committed to providing powerful WhatsApp automation and chatbot tools tailored for small businesses and marketers. This Policy explains how you can cancel your subscription, when refunds may be applicable, and the process for submitting a refund request.</motion.p>
        <motion.p
            className="section-text"
            variants={itemVariant}>By using our Service, you acknowledge and accept the terms outlined below.</motion.p>

          <motion.h2 className="section-heading" variants={fadeUp}>2. Subscription Cancellation Policy</motion.h2>
          <motion.ul variants={itemVariant}>
           <motion.li
              whileHover={{ x: 5 }}
              transition={{ duration: 0.2 }}>Users may cancel their subscription at any time from their ONBBITS dashboard.</motion.li>
             <motion.li
              whileHover={{ x: 5 }}
              transition={{ duration: 0.2 }}>Cancellations take effect at the end of the current billing cycle (monthly or annually).</motion.li>
             <motion.li
              whileHover={{ x: 5 }}
              transition={{ duration: 0.2 }}>You will continue to have access to all features until the billing cycle ends.</motion.li>
             <motion.li
              whileHover={{ x: 5 }}
              transition={{ duration: 0.2 }}>No partial refunds or prorated credits will be provided for unused time within the billing period.</motion.li>
            </motion.ul>

            <motion.h2 className="section-heading" variants={fadeUp}>3. Refund Eligibility</motion.h2>
            <motion.p
            className="section-text"
            variants={itemVariant}>We do not offer refunds on subscription fees once a payment is processed, except under the following condition:</motion.p>
            <motion.p
            className="section-text"
            variants={itemVariant}>Duplicate charges or other billing errors caused by ONBBITS.</motion.p>

            <motion.h2 className="section-heading" variants={fadeUp}>4. Non-Refundable Items</motion.h2>
             <motion.p
            className="section-text"
            variants={itemVariant}>The following payments are strictly non-refundable, even if the associated service has not been used in full:</motion.p>
            <motion.ul variants={itemVariant}>
           <motion.li
              whileHover={{ x: 5 }}
              transition={{ duration: 0.2 }}>One-time add-ons such as onboarding, funnel setup, or API integration once activated or work has commenced.</motion.li>
             <motion.li
              whileHover={{ x: 5 }}
              transition={{ duration: 0.2 }}>Subscription fees after the payment has been processed and access granted.</motion.li>
             <motion.li
              whileHover={{ x: 5 }}
              transition={{ duration: 0.2 }}>Third-party charges (e.g., WhatsApp Business API provider fees) not billed directly by ONBBITS.</motion.li>
            </motion.ul>

            <motion.h2 className="section-heading" variants={fadeUp}>5. How to Request a Refund</motion.h2>
            <motion.p
            className="section-text"
            variants={itemVariant}>To request a refund under eligible conditions:</motion.p>
            <motion.ol variants={itemVariant}>
           <motion.li
              whileHover={{ x: 5 }}
              transition={{ duration: 0.2 }}>Email us at <a href="mailto:info@onbbits.io">info@onbbits.io</a> with the subject line: Refund Request – [Your Account Email].</motion.li>
            <motion.li
              whileHover={{ x: 5 }}
              transition={{ duration: 0.2 }}>Include the following details:
              <motion.ul variants={itemVariant}>
           <motion.li
              whileHover={{ x: 5 }}
              transition={{ duration: 0.2 }}>Your registered email ID</motion.li>
              <motion.li
              whileHover={{ x: 5 }}
              transition={{ duration: 0.2 }}>Invoice number or transaction ID</motion.li>
              <motion.li
              whileHover={{ x: 5 }}
              transition={{ duration: 0.2 }}>Reason for your request, with relevant documentation (if applicable)</motion.li>
              </motion.ul>
              </motion.li>
            </motion.ol>
            <motion.p
            className="section-text"
            variants={itemVariant}>Refund requests must be submitted within 7 days of the billing date. Our team will review and respond within 5 business days.</motion.p>

             <motion.h2 className="section-heading" variants={fadeUp}>6. Exceptional Circumstances</motion.h2>
             <motion.p
            className="section-text"
            variants={itemVariant}>We may, at our sole discretion, issue a refund in exceptional cases not covered above. These may include:</motion.p>
            <motion.ul variants={itemVariant}>
           <motion.li
              whileHover={{ x: 5 }}
              transition={{ duration: 0.2 }}>Proven inability to access the platform despite proper setup and usage.</motion.li>
            <motion.li
              whileHover={{ x: 5 }}
              transition={{ duration: 0.2 }}>Technical failures unresolved after reasonable troubleshooting efforts with our support team.</motion.li>
            </motion.ul>
            <motion.p
            className="section-text"
            variants={itemVariant}>Such cases will be reviewed individually and do not set a precedent for future claims.</motion.p>

            <motion.h2 className="section-heading" variants={fadeUp}>7. Changes to This Policy</motion.h2>
            <motion.p
            className="section-text"
            variants={itemVariant}>ONBBITS reserves the right to amend this Cancellation and Refund Policy at any time. Updates will be posted on our website with the "Effective Date" at the top of this page.</motion.p>
            <motion.p
            className="section-text"
            variants={itemVariant}>We recommend reviewing this Policy periodically. Continued use of ONBBITS after changes take effect constitutes acceptance of the revised Policy.</motion.p>
        </motion.section>

        {/**CTA SECTION */}
        <Cta />
        </>
    )
}
export default CancellationRefund;